import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";

export type ComparePlanButtonStateForReport = {
    showDifferenceBetweenPlansForReport: boolean
}
export const EMPTY_COMPARE_PLAN_BUTTON_STATE_FOR_REPORT: ComparePlanButtonStateForReport = {
    showDifferenceBetweenPlansForReport: false
}

export interface ComparePlansState {
    showDifferenceBetweenPlans: boolean;
    showSelectPlans?: boolean;
    comparePlanPageActionMenuForReport: ComparePlanButtonStateForReport;
}

export const initialState: ComparePlansState = {
    showDifferenceBetweenPlans: false,
    showSelectPlans: true,
    comparePlanPageActionMenuForReport: EMPTY_COMPARE_PLAN_BUTTON_STATE_FOR_REPORT
};

export const comparePlansSlice = createSlice({
    name: "comparePlans",
    initialState,
    reducers: {
        setDifferenceBetweenPlans: (state, action: PayloadAction<boolean>) => {
            state.showDifferenceBetweenPlans = action.payload;
        },
        setDifferenceBetweenPlansForReport: (state, action: PayloadAction<boolean>) => {
            state.comparePlanPageActionMenuForReport.showDifferenceBetweenPlansForReport = action.payload;
        },
        resetDifferenceBetweenPlans: (state) => {
            state.showDifferenceBetweenPlans = false;
        },
        resetDifferenceBetweenPlansForReport: (state) => {
            state.comparePlanPageActionMenuForReport.showDifferenceBetweenPlansForReport = false;
        },
        setComparePlanPageActionMenuForReport: (state, action: PayloadAction<ComparePlanButtonStateForReport>) => {
            state.comparePlanPageActionMenuForReport = action.payload;
        },
        setSelectPlans: (state, action: PayloadAction<boolean>) => {
            state.showSelectPlans = action.payload;
        },
    },
});

export const {
    setDifferenceBetweenPlans,
    resetDifferenceBetweenPlans,
    resetDifferenceBetweenPlansForReport,
    setDifferenceBetweenPlansForReport,
    setComparePlanPageActionMenuForReport,
    setSelectPlans
} = comparePlansSlice.actions;

export const selectShowPlans = (state: RootState) => state.client.comparePlans.showSelectPlans;
export const selectDifferenceBetweenPlans = (state: RootState) => state.client.comparePlans.showDifferenceBetweenPlans;
export const selectComparePlanPageActionMenuForReport = (state: RootState) => state.client.comparePlans.comparePlanPageActionMenuForReport;
export default comparePlansSlice.reducer;